"use client"; // Error components must be Client Components
import { CR_URL } from "@/components/cryptoread/common/constant";
import Loading from "./loading";
import { useEffect } from "react";

export default function Error() {

  useEffect(()=>{
    window.location.href = CR_URL
  },[])

  return <Loading />;
}
